module.exports = __webpack_public_path__ + "img/arm-left-front.570aa53a.png";